<template>
  <div id="box">
    <div id="banner">
      <img src="../../src/assets/banner.jpeg" alt="" />
    </div>
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      ref="ruleForm2"
      label-position="left"
      class="demo-ruleForm"
    >
      <div class="login-container">
        <h3 class="title">龙杰一拍通登录</h3>
        <el-form-item prop="account">
          <el-input
            type="text"
            v-model="ruleForm2.account"
            auto-complete="off"
            placeholder="账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm2.checkPass"
            auto-complete="off"
            placeholder="密码"
            maxlength="8"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item prop="verifyCode">
          <el-input
            prefix-icon="login_yzm"
            class="inputGroup3"
            type="text"
            style="width: 120px"
            v-model="ruleForm2.verifyCode"
            auto-complete="off"
            placeholder="验证码"
          ></el-input>
          <div
            class="vcode"
            v-html="htmlscode"
            @click="switchVerificationCode"
          ></div>
        </el-form-item>
        <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
        <el-form-item style="width: 100%">
          <el-button
            type="primary"
            style="width: 100%; background: #0066ff"
            @click.native.prevent="handleSubmit2"
            :loading="logining"
            >登&nbsp;&nbsp;&nbsp;录</el-button
          >
          <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
        </el-form-item>
      </div>
    </el-form>
    <div class="dot">
      <p>
        © 龙杰科技（深圳）有限公司.受法律保护
        <a href="https://beian.miit.gov.cn">粤ICP备16016531号</a>
      </p>
    </div>
  </div>
</template>

<script>
import { getCode, requestLogin, getMenuList } from '@/api/api';
import { generateTreeStructure, processRoutingStructure } from '@/utils/index';
//import NProgress from 'nprogress'
export default {
  data() {
    return {
      logining: false,
      ruleForm2: {
        account: 'admin',
        checkPass: 'admin888',
        verifyCode: '',
      },
      htmlscode: '',
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      // checked: true,
      routers: [],
    };
  },
  created() {
    this.getVcode();
    // getMenuList().then(res => {
    //   console.log(res);
    //   spliceRoutingInformation(res.data)
    // });
  },
  methods: {
    // handleReset2() {
    //   this.$refs.ruleForm2.resetFields();
    // },
    //获取验证码
    getVcode() {
      getCode().then((res) => {
        this.htmlscode = res;
      });
    },
    handleSubmit2(ev) {
      var _this = this;
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true;
          var loginParams = {
            username: this.ruleForm2.account,
            password: this.ruleForm2.checkPass,
            verify: this.ruleForm2.verifyCode,
          };
          requestLogin(loginParams).then((data) => {
            this.logining = false;
            if (data.errno == 0) {
              let user = data.data.userInfo;
              let token = data.data.token;
              this.$store.commit('LOCIN_IN', token);
              this.$store.commit('MODIFY_USER', user);
              console.log(data.data.userInfo.menu);
              sessionStorage.setItem('user', JSON.stringify(user));
              let routeList = processRoutingStructure(data.data.userInfo.menu);
              window.sessionStorage.setItem(
                'menu',
                JSON.stringify(data.data.userInfo.menu)
              );
              this.$router.addRoutes(routeList);
              this.$router.push({ path: '/charts/echarts' });
              // this.getMenuLists();
            } else {
              this.$message.error(data.errmsg);
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    // //获取menu菜单列表
    // getMenuLists() {
    //   getMenuList().then(res => {
    //     if (res.errno == 0) {
    //       console.log();
    //       let menuList = generateTreeStructure(res.data);
    //       let routeList = processRoutingStructure(menuList);
    //       window.sessionStorage.setItem("menu", JSON.stringify(menuList));
    //       this.$router.addRoutes(routeList);
    //       this.$router.push({ path: "/charts/echarts" });
    //     }
    //   });
    // },
    switchVerificationCode() {
      this.getVcode();
    },
  },
};
</script>

<style lang="scss" scoped>
#box {
  overflow: hidden;
}
#banner {
  width: 100%;
  height: 100%;
  top: 0;
  z-index: -999;
  position: absolute;
}
#banner img {
  display: block;
  outline: none;
  border: 0;
  height: 100%;
  width: 100%;
}
.login-container {
  position: fixed;
  top: 22%;
  left: 48%;
  // -webkit-border-radius: 5px;
  background-clip: padding-box;
  width: 280px;
  padding: 35px 35px 15px 35px;
  background: rgba(248, 248, 255, 0.4);
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #330000;
    font-size: 24px;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
  .vcode {
    float: right;
    width: 110px;
    height: 40px;
    border-radius: 5px !important;
  }
}
.dot {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  p {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?579883d5